import React, { useContext } from 'react'
import { bool, oneOfType, string } from 'prop-types'
import { TextContext } from 'hocs'
import * as Styled from './NoCompareValue.styles'
import { WordHints } from 'components/molecules'

const NoCompareValue = ({ compareKey, qsr, hint }) => {
  const textContext = useContext(TextContext)
  return (
    <Styled.NoCompareValue key={ `no-value-${ compareKey }` }>
      <>
        {qsr && (
          <WordHints
            className='word-hint'
            title={ textContext['quality.headline.qsr'] }
            hint={ hint }
          />
        )}
        <p>
          {compareKey}
          <br />
          {!qsr && textContext['compare.dataRow.noCompareValue']}
        </p>
      </>
    </Styled.NoCompareValue>
  )
}

NoCompareValue.defaultProps = {
  qsr: false,
  hint: false,
}

NoCompareValue.propTypes = {
  compareKey: string,
  qsr: bool,
  hint: oneOfType([bool, string]),
}

export default NoCompareValue
